<template>
  <el-dialog title="二维码" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="450px">
    <img v-img-url="qrcode" class="qrcodestyle" alt="小程序名片码" />
  </el-dialog>
</template>

<script>

export default {
  data() {
    return {
        /*是否显示*/
      dialogVisible: true,
    };
  },
  props: ['is_show', 'qrcode'],
  watch:{

  },  
  created() {
  },
  methods: {
    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit('closeDialog', {
        type: this.type,
        openDialog: false,
        params: this.params
      });
    },
  }
};
</script>

<style>
.qrcodestyle{
    width: 200px;
    height: 200px;
    text-align: center;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/card/cardlist/code.vue